import React from 'react';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

function Sidebar(props) {
    return (
        <ul className={"navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" + (props.toggled ? " toggled" : "")}
            id="accordionSidebar">

            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to={"/app/dashboard"}>
                <div className="sidebar-brand-icon rotate-n-15">
                    <FontAwesomeIcon icon={solid('plane-departure')}/>
                </div>
                <div className="sidebar-brand-text mx-3">takeControl Web</div>
            </Link>

            <hr className="sidebar-divider my-0"/>

            <li className="nav-item">
                <Link className="nav-link" to="/app/dashboard">
                    <FontAwesomeIcon icon={solid('tachometer-alt')} className="fa-fw"/>
                    <span>Dashboard</span></Link>
            </li>

            {/*<li className="nav-item">*/}
            {/*    <Link className="nav-link" to={"/calendar"}>*/}
            {/*        <FontAwesomeIcon icon={solid('calendar')} className="fa-fw"/>*/}
            {/*        <span>Calendar</span></Link>*/}
            {/*</li>*/}

            <hr className="sidebar-divider"/>

            <div className="sidebar-heading">
                Tasks
            </div>

            <li className="nav-item">
                <Link className="nav-link" to="/app/planner">
                    <FontAwesomeIcon icon={solid('pencil-ruler')} className="fa-fw"/>
                    <span>Planner</span>
                </Link>
            </li>

            {/*<li className="nav-item">*/}
            {/*    <Link className="nav-link" to="/app/money">*/}
            {/*        <FontAwesomeIcon icon={solid('coins')} className="fa-fw"/>*/}
            {/*        <span>Money</span>*/}
            {/*    </Link>*/}
            {/*</li>*/}

            {/*<li className="nav-item">*/}
            {/*    <Link className="nav-link" to="/app/creditsshop">*/}
            {/*        <FontAwesomeIcon icon={solid('coins')}/>*/}
            {/*        <span>Shop</span>*/}
            {/*    </Link>*/}
            {/*</li>*/}

            <li className="nav-item">
                <Link className="nav-link" to="/app/goals">
                    <FontAwesomeIcon icon={solid('tasks')} className="fa-fw"/>
                    <span>Goals</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/app/statistics">
                    <FontAwesomeIcon icon={solid('chart-line')} className="fa-fw"/>
                    <span>Statistics</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/app/goalhistory">
                    <FontAwesomeIcon icon={solid('chart-area')} className="fa-fw"/>
                    <span>Goal History</span>
                </Link>
            </li>

            <hr className="sidebar-divider"/>

            <div className="sidebar-heading">
                Food
            </div>

            <li className="nav-item">
                <Link className="nav-link" to="/app/foodplanner">
                    <FontAwesomeIcon icon={solid('apple-alt')} className="fa-fw"/>
                    <span>Food Planner</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/app/scanner">
                    <FontAwesomeIcon icon={solid('barcode')} className="fa-fw"/>
                    <span>Food Scanner</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/app/fooddata">
                    <FontAwesomeIcon icon={solid('apple-alt')} className="fa-fw"/>
                    <span>Food Data</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/app/shoplist">
                    <FontAwesomeIcon icon={solid('scroll')} className="fa-fw"/>
                    <span>Shopping List</span>
                </Link>
            </li>

            {/*<li className="nav-item">*/}
            {/*    <Link className="nav-link" to="/app/food">*/}
            {/*        <FontAwesomeIcon icon={solid('apple-alt')} className="fa-fw"/>*/}
            {/*        <span>Food (deprecated)</span>*/}
            {/*    </Link>*/}
            {/*</li>*/}

            {/*<hr className="sidebar-divider"/>*/}

            {/*<div className="sidebar-heading">*/}
            {/*    Money*/}
            {/*</div>*/}

            {/*<li className="nav-item">*/}
            {/*    <Link className="nav-link" to="/">*/}
            {/*        <FontAwesomeIcon icon={solid('table')} className="fa-fw"/>*/}
            {/*        <span>Overview</span></Link>*/}
            {/*</li>*/}

            {/*<li className="nav-item">*/}
            {/*    <Link className="nav-link" to="/">*/}
            {/*        <FontAwesomeIcon icon={solid('chart-area')} className="fa-fw"/>*/}
            {/*        <span>Balance</span></Link>*/}
            {/*</li>*/}

            <hr className="sidebar-divider"/>

            <div className="sidebar-heading">
                SOCIAL
            </div>

            <li className="nav-item">
                <Link className="nav-link" to="/app/wishlists">
                    <FontAwesomeIcon icon={solid('pencil-ruler')} className="fa-fw"/>
                    <span>Wish Lists</span>
                </Link>
            </li>


            <hr className="sidebar-divider d-none d-md-block"/>

            <div className="sidebar-heading">
                Help
            </div>


            <li className="nav-item">
                <Link className="nav-link" to="/app/commands">
                    <FontAwesomeIcon icon={solid('question')} className="fa-fw"/>
                    <span>Commands</span></Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/app/problems">
                    <FontAwesomeIcon icon={solid('wrench')} className="fa-fw"/>
                    <span>Problems</span></Link>
            </li>

            <hr className="sidebar-divider d-none d-md-block"/>

            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle"
                        onClick={props.onSidebarToggle}>
                    <FontAwesomeIcon icon={solid('bars')} className="fa-fw"/>
                </button>
            </div>
        </ul>
    );
}

export default Sidebar;
